import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { loginWithEmail } from './LoginManager';
import { getAuth, sendPasswordResetEmail } from 'firebase/auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope, faLock, faCheckCircle } from '@fortawesome/free-solid-svg-icons';
import SocialMedia from './SocialMedia';
import toast from 'react-hot-toast';

const SignInForm = ({ handleResponse }) => {
    const { register, handleSubmit, formState: { errors } } = useForm();
    const [view, setView] = useState('login');         
    const [resetEmail, setResetEmail] = useState('');
    const [linkSent, setLinkSent] = useState(false);   

    
    const onSubmit = async ({ email, password }) => {
        const loading = toast.loading('Please wait...');
        const res = await loginWithEmail(email, password);
        toast.dismiss(loading);

        if (res.error) {
            toast.error(res.error);
            return;
        }

        handleResponse(res);
        toast.success('Login successful');
    };
 
    const handleForgotPassword = async (e) => {
        e.preventDefault();
        if (!resetEmail) {
            toast.error('Please enter your email');
            return;
        }
        const loading = toast.loading('Sending reset link...');
        try {
            const auth = getAuth();
            await sendPasswordResetEmail(auth, resetEmail);
            toast.dismiss(loading);
            setLinkSent(true);  
        } catch (error) {
            toast.dismiss(loading);
            toast.error('No account found with this email.');
        }
    };

   
    if (view === 'login') {
        return (
            <form onSubmit={handleSubmit(onSubmit)} className="sign-in-form">
                <h2 className="title">Sign in</h2>

                <div className="input-field">
                    <span className="fIcon">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </span>
                    <input
                        type="email"
                        placeholder="Email"
                        {...register("email", { required: true })}
                    />
                </div>
                {errors.email && <span className="text-warning">Email is required</span>}

                <div className="input-field">
                    <span className="fIcon">
                        <FontAwesomeIcon icon={faLock} />
                    </span>
                    <input
                        type="password"
                        placeholder="Password"
                        {...register("password", { required: true })}
                    />
                </div>
                {errors.password && <span className="text-warning">Password is required</span>}

                 
                <p
                    onClick={() => { setView('forgot'); setLinkSent(false); }}
                    style={{
                        textAlign: 'right',
                        cursor: 'pointer',           
                        color: '#29abe2',
                        fontSize: '13px',
                        margin: '6px 0 14px',
                        fontWeight: '500',
                        userSelect: 'none',
                    }}
                >
                    Forgot Password?
                </p>

                <input className="iBtn" type="submit" value="Sign In" />

                <p className="social-text">Or sign in with social platforms</p>
                <SocialMedia handleResponse={handleResponse} />
            </form>
        );
    }

    
    if (view === 'forgot') {
        return (
            <form onSubmit={handleForgotPassword} className="sign-in-form">
                <h2 className="title">Reset Password</h2>
                <p className="social-text">
                    Enter your email and we'll send you a reset link.
                </p>

                
                {linkSent && (
                    <div style={{
                        background: '#e6f9f0',
                        border: '1px solid #34d399',
                        borderRadius: '8px',
                        padding: '12px 16px',
                        marginBottom: '16px',
                        display: 'flex',
                        alignItems: 'center',
                        gap: '10px',
                        color: '#065f46',
                        fontSize: '14px',
                        fontWeight: '500',
                    }}>
                        <FontAwesomeIcon icon={faCheckCircle} style={{ color: '#10b981', fontSize: '18px' }} />
                        <span>
                            Reset link sent to <strong>{resetEmail}</strong>. Please check your inbox.
                        </span>
                    </div>
                )}

                <div className="input-field">
                    <span className="fIcon">
                        <FontAwesomeIcon icon={faEnvelope} />
                    </span>
                    <input
                        type="email"
                        placeholder="Enter your registered email"
                        value={resetEmail}
                        onChange={(e) => { setResetEmail(e.target.value); setLinkSent(false); }}
                        required
                    />
                </div>

                <input
                    className="iBtn"
                    type="submit"
                    value={linkSent ? 'Resend Link' : 'Send Reset Link'}
                />

                
                <p
                    onClick={() => { setView('login'); setLinkSent(false); setResetEmail(''); }}
                    style={{
                        textAlign: 'center',
                        cursor: 'pointer',       
                        color: '#29abe2',
                        fontSize: '13px',
                        marginTop: '14px',
                        fontWeight: '500',
                        userSelect: 'none',
                    }}
                >
                    ← Back to Login
                </p>
            </form>
        );
    }
};

export default SignInForm;
